import { useMutation } from "@tanstack/react-query";

import { AdmireUserRequest, unadmireUser } from "@/api";


const useUnadmireUser = () => {
  return useMutation({
    mutationFn: ({ userId }: AdmireUserRequest) => {
      return unadmireUser({ userId });
    },
  });
};

export { useUnadmireUser };
